export interface ISidebar<T> {
    component : any;
    data : T;
    title : string;
    width ?: number; // in rem
}

export interface ISidebarAction<T> {
    data : T;
    action : ISidebarActionEnum
}

export enum  ISidebarActionEnum {
    CLOSE = "CLOSE",
    DATA_RETURN = "DATA_RETURN",
}